/**
 *  @flow
 */

import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import { Modal, Button } from '../../../components';
import { SeminarForm } from './form';

import type { ReduxForm } from '../../../type';

type AddSeminarDialogProps = {
    // The trigger (usually button) that oppens this form
    trigger: Object,
    onClose: Function,
} & ReduxForm;

const AddSeminarDialog = ({
    trigger,
    open,
    onClose,
    handleSubmit,
    submitting,
    pristine,
    error,
    form,
}: AddSeminarDialogProps) => (
    <Modal trigger={trigger} onClose={onClose} open={open}>
        <Modal.Header>
            <FormattedMessage
                id="pages.seminars.AddSeminarDialog.header"
                defaultMessage="New Seminar"
            />
        </Modal.Header>
        <Modal.Content>
            {error && (
                <Message error>
                    <Icon name="warning sign" />
                    {error}
                </Message>
            )}
            <SeminarForm
                handleSubmit={handleSubmit}
                submitting={submitting}
                pristine={pristine}
                form={form}
            />
        </Modal.Content>
        <Modal.Actions>
            <Button
                onClick={handleSubmit}
                disabled={pristine || submitting}
                loading={submitting}
                primary
            >
                <FormattedMessage
                    id="pages.seminars.AddSeminarDialog.add"
                    defaultMessage="Add"
                />
            </Button>
            <Button onClick={onClose} disabled={submitting} basic>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.seminars.AddSeminarDialog.cancel"
                    defaultMessage="Cancel"
                />
            </Button>
        </Modal.Actions>
    </Modal>
);

export default AddSeminarDialog;
